import request from '@/utils/request'

export const getItems = params => request.get('/accounting/items', { params })

export const createItem = data => request.post('/accounting/items', data)

export const getItem = id => request.get(`/accounting/items/${id}`)

export const updateItem = (id, data) => request.put(`/accounting/items/${id}`, data)

export const deleteItem = id => request.delete(`/accounting/items/${id}`)

export const createItemReceipt = (id, data) => request.post(`/accounting/items/${id}/receipts`, data)
